import { render, staticRenderFns } from "./handItem1.vue?vue&type=template&id=470c18e3&scoped=true"
import script from "./handItem1.vue?vue&type=script&lang=js"
export * from "./handItem1.vue?vue&type=script&lang=js"
import style0 from "./handItem1.vue?vue&type=style&index=0&id=470c18e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470c18e3",
  null
  
)

export default component.exports